// this is an autogenerated file from App/Account/Content/Settings/Content/Charges/Content/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Settings_Content_Charges_Content($location_id: numeric!) {
  vaxiom_misc_fee_charge_templates(
    where: { organization_id: { _eq: $location_id } }
    order_by: { name: asc }
  ) {
    id
    name
    price
    insurance_code_id
    affecting_production_report
    is_included_in_insurance_claim
    requires_tooth_details
    sys_created
    sys_last_modified
    insurance_code {
      id
      code
    }
    procedures: procedure_misc_fee_charge_templates {
      procedure_id
      misc_fee_charge_template_id
    }
  }
}

`